/*global define, console, window, HTMLImageElement, Promise*/

(function (root, factory) {
    "use strict";
    if (typeof define === 'function' && define.amd) {
        define("ClickableMap", ["jquery", "Behaviors"], factory);
    } else {
        root.ClickableMap = factory(root.jQuery, root.Behaviors);
    }
}(this, function ($, Behaviors) {
    "use strict";
    var module = {};

    function ClickableMap() {
        Behaviors.init(ClickableMap, this, arguments);
        this.element = this.$elem[0];


        $('#map .pin').each(function(){
            $(this).click(function(e){
                var targetId =  e.target.getAttribute('data-target-id');

                $('#' + targetId).trigger('click');

            });
        });

         $('path[id],polygon[id]').click(function(){
            
            if( $('#' + $(this).attr('id') + '-pin').length ){ 

                $('#' + $(this).attr('id') + '-pin').trigger('click');
                
            }
            
           
        });


        $('path[id],polygon[id]').hover(function(){
            if($(this).hasClass('selected')){

            }else{
                $('#' + $(this).attr('id') + '-pin').toggleClass('active');
            }
            
        }, function(){
            if($(this).hasClass('selected')){

            }else{
                $( '#' + $(this).attr('id') + '-pin').toggleClass('active');
            }
           
        });


        $('#map path.pin').hover(function(){
            if($(this).hasClass('selected')){

            }else{
                $('#' + $(this).attr('id').replace('-pin','')).toggleClass('active');
                $(this).toggleClass('active');
            }
            
        },function(){
            if($(this).hasClass('selected')){
                
            }else{
                $('#' + $(this).attr('id').replace('-pin','')).toggleClass('active');
                $(this).toggleClass('active');
            }
           
        });

        $('.location-name').click(function(){
            
            // $('.location-content').each(function(){
            //     // if($(this).hasClass('active')){
            //     //     $(this).removeClass('active');
            //     // }

            //      if($(this).hasClass('active')){
            //         $(this).removeClass('active');
            //         $(this).slideUp(350);
            //     }else{
            //         $(this).removeClass('active');
            //         $(this).slideUp(350);
            //     }
            // });

            var locID = $(this).attr('id');

            $('.location-content').each(function(){
                 if( $(this).prev().attr('id') != locID){
                    if($(this).hasClass('active')){
                         $(this).removeClass('active');
                         $(this).slideToggle(350);
                    }
                }
            });
 

            if($(this).next().hasClass('active')){
                $(this).next().removeClass('active');
                $(this).next().slideUp(350);
            }else{
                $(this).next().toggleClass('active');
                $(this).next().slideToggle(350);
            }
          

            $('.location-name').each(function(){
                if($(this).hasClass('active')){
                    console.log('found and removing');
                    $(this).removeClass('active');
                    $(this).removeClass('selected');
                }
            });

            $('#map .active').each(function(){
                if($(this).hasClass('active')){
                    $(this).removeClass('active');
                    $(this).removeClass('selected');
                }
            });

            $('#' + $(this).data('location-id') ).addClass('active').addClass('selected'); //highlight map area

            $('#' + $(this).data('location-id') + '-pin').addClass('active').addClass('selected'); //highlight pin
            
            $(this).addClass('active').addClass('selected');
            // $(this).next().addClass('active');
            
        });
        
    }

    Behaviors.inherit(ClickableMap, Behaviors.Behavior);

    ClickableMap.QUERY = "[data-ClickableMap]";

    ClickableMap.ELEMENTS = {
       
    };

    
    Behaviors.register_behavior(ClickableMap);

    module.ClickableMap = ClickableMap;


    return module;
}));
